import { render, staticRenderFns } from "./StepInfoHeader.vue?vue&type=template&id=0b2ef27e&scoped=true"
import script from "./StepInfoHeader.vue?vue&type=script&lang=js"
export * from "./StepInfoHeader.vue?vue&type=script&lang=js"
import style0 from "./StepInfoHeader.vue?vue&type=style&index=0&id=0b2ef27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ef27e",
  null
  
)

export default component.exports